import React from 'react'
import { WidgetCard } from '../style'
import { DocumentList } from '../widgets/SegmentationTableWidget/style'
import { SkeletonLine } from './skeleton.style'

const SegmentationTableWidgetSkeleton: React.FC = () => (
  <WidgetCard>
    <DocumentList>
      {[...Array(5)].map((_, i) => (
        <SkeletonLine key={i} width={`${140 + i * 20}px`} height='16px' style={{ marginBottom: 0 }} />
      ))}
    </DocumentList>
  </WidgetCard>
)

export default SegmentationTableWidgetSkeleton
